const FullScreenLoader = ({ text = "Loading..." }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-white/70"
      role="alert"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-3">
        {/* <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-gray-800" />
        <span className="text-sm text-gray-600">{text}</span> */}
        {/* <span className="loading loading-dots loading-xl"></span> */}
        {/* <Loaders></Loaders> */}
        <DotSpinnerLoader />
      </div>
    </div>
  );
};

// DotSpinnerLoader - Dots arranged in a circle spinning
export const DotSpinnerLoader = ({ color = "blue", size = 25 }) => {
  const colorMap = {
    blue: "bg-blue-500",
    green: "bg-green-500",
    red: "bg-red-500",
    purple: "bg-purple-500",
    yellow: "bg-yellow-500",
    black: "bg-black",
  };
  const bgColor = colorMap[color] || colorMap.blue;

  const dots = 10;
  const radius = size;

  return (
    <div className="relative w-12 h-12">
      {[...Array(dots)].map((_, i) => {
        const angle = (i * 360) / dots;
        const x = Math.cos((angle * Math.PI) / 180) * radius;
        const y = Math.sin((angle * Math.PI) / 180) * radius;
        return (
          <div
            key={i}
            className={`absolute w-2 h-2 ${bgColor} rounded-full`}
            style={{
              left: `calc(50% + ${x}px - 4px)`,
              top: `calc(50% + ${y}px - 4px)`,
              opacity: 0.3 + (i / dots) * 0.7,
              animation: `dotSpin 1.2s linear infinite`,
              animationDelay: `${(i / dots) * 1.2}s`,
            }}
          ></div>
        );
      })}
      <style>{`
        @keyframes dotSpin {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};
export default FullScreenLoader;
